import validator from 'validator';

export default function isValidEmail(email) {
  if (!validator.isEmail(email || '')) {
    return false;
  }
  // Additional check to prevent invalid TLDs that validator allows such as 'kabelmail.deö' (presumably a typo of 'kabelmail.de')
  const tldPart = email.substring(email.lastIndexOf('.') + 1);
  if (!/^[a-zA-Z0-9-]+$/.test(tldPart)) {
    return false;
  }
  return true;
}
